import toastr from "toastr";

export const pageImage = {
    // ロード完了したとき
    loadDone: function (results) {
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);

        //初回画像読み込み
        $(".js-load-image").map(function () {
            const imageId = $(this).data("imageid");
            pageImage.loadImageItem(imageId);
        });

        // 全て押す選択ボタンの定義
        $(".button-small--select").unbind();
        $(".button-small--select").click(function () {
            $('[name="deleteTargetImageId"]').prop("checked", true);
        });

        modalWindow.enableButton();
        pageImage.enableButton();

        // ドラッグアンドドロップ部分の定義
        $(".js-content").unbind();
        $(".js-content").on("dragover", function (ev) {
            ev.preventDefault();
        });
        $(".js-content").on("drop", function (ev) {
            ev.preventDefault();
            const files = ev.originalEvent.dataTransfer.files;
            $(".js-upload-file-top").prop("files", files);
            $(".js-upload-file-top").trigger("change");
        });

        $(".js-upload-file-top").unbind();
        $(".js-upload-file-top").change(function () {
            const files = $(this).prop("files");
            (async () => {
                for await (const file of files) {
                    const paramList = new FormData();
                    // 画像の圧縮
                    await form.compressImage(paramList, file);

                    paramList.append("typeId", $(this).data("typeid"));
                    post.postAjaxData(
                        "/nursery/image/upload/",
                        paramList,
                        "",
                        pageImage.uploadImageDone,
                        pageImage.uploadImageFail,
                        null,
                        false
                    );
                }
            })();
        });

        // ソートの設定
        $("#sortable").unbind();
        $("#sortable").sortable({
            opacity: 0.5, // ドラッグ中の透明度
            update: pageImage.sortDone
        });
    },

    //ソート完了
    sortDone: function () {
        //初回画像読み込み
        let position = 1;
        const paramList = new FormData();
        $(".js-load-image").map(function () {
            const imageId = $(this).data("imageid");
            paramList.append("id[" + position + "]", imageId);
            position++;
        });

        paramList.append("typeId", $(".js-upload-file-top").data("typeid"));
        post.postAjaxData("/nursery/image/updatePosition", paramList, "", null, null, null);
    },

    // 画像アイテムの
    loadImageItem: function (imageId) {
        const paramList = new FormData();
        paramList.append("id", imageId);

        post.postAjaxData("/nursery/image/getImage", paramList, "", pageImage.imageItemLoadDone, null, null);
    },
    // アイテムの起動が完了
    imageItemLoadDone: function (results, paramList) {
        $('[data-imageid="' + paramList.get("id") + '"]').html(results["template"]);

        // 削除ボタンの定義
        modalWindow.enableButton();
        pageImage.enableButton();
    },

    // 画像の削除
    deleteImage: function (imageId) {
        const paramList = new FormData();
        paramList.append("id", imageId);

        post.postAjaxData("/nursery/image/delete", paramList, "", pageImage.deleteImageDone, null, null);
    },

    // 削除完了
    deleteImageDone: function (results, paramList) {
        $('[data-imageid="' + paramList.get("id") + '"] .js-btn-delete')
            .parents(".js-load-image")
            .remove();
    },

    // 画像のアップロードが完了
    uploadImageDone: function (results) {
        // 成功したときのコールバック
        $(".contact-complete").remove();
        $(".nursery-photo__list").append(results["template"]);
        pageImage.loadImageItem(results["imageId"]);
    },

    // 失敗。バリデーション失敗のときにも発生
    uploadImageFail: function (jqXHR) {
        // エラーの表示する。
        for (const key in jqXHR["responseJSON"]["errors"]) {
            const messageString = jqXHR["responseJSON"]["errors"][key];
            if (messageString != "") {
                toastr.options = {
                    closeButton: false,
                    debug: false,
                    newestOnTop: false,
                    progressBar: false,
                    positionClass: "toast-bottom-full-width",
                    preventDuplicates: false,
                    onclick: null,
                    showDuration: "300",
                    hideDuration: "1000",
                    timeOut: "5000",
                    extendedTimeOut: "1000",
                    showEasing: "swing",
                    hideEasing: "linear",
                    showMethod: "fadeIn",
                    hideMethod: "fadeOut"
                };
                toastr.error(messageString);
            }
        }

        $("#js-nav-pagetop").trigger("click");
    },
    // 編集ボタン・削除ボタンを押したときの定義
    enableButton: function () {
        // 選択されているものを削除
        $("#js-modal-selected-delete .button-small--yes").click(function () {
            const selectedList = $('[name="deleteTargetImageId"]:checked');
            if (selectedList.length === 0) {
                return;
            }

            $('[name="deleteTargetImageId"]:checked').each(function () {
                pageImage.deleteImage($(this).val());
            });
        });

        // 単体の削除
        // 選択されているものを削除
        $(".js-btn-delete").click(function () {
            $("#js-modal-delete .button-small--yes").data("imageid", $(this).data("imageid"));
            modalWindow.showModal("#js-modal-delete");
        });
        $("#js-modal-delete .button-small--yes").click(function () {
            pageImage.deleteImage($(this).data("imageid"));
        });

        // 特徴を追加、編集を押したとき
        $(".js-btn-edit").unbind();
        $(".js-btn-edit").click(function () {
            const paramList = new FormData();
            paramList.append("id", $(this).data("imageid"));

            post.postAjaxData("/nursery/image/edit", paramList, "", pageImage.editLoadDone, null, null);
        });
    },

    // 編集画面の読み込み完了
    editLoadDone: function (results) {
        $(".js-edit-image-area").html(results["template"]);

        // modal表示
        modalWindow.showModal("#js-modal-edit");

        // 削除ボタンの定義
        modalWindow.enableButton();
        pageImage.enableButton();

        // 保存ボタンを押した
        imagePreview.preview(".nursery__upload-area--modal", ".nursery-photo__modal-pict");

        // 保存ボタンを押したとき
        $(".js-upload-button").unbind();
        $(".js-upload-button").click(function () {
            form.disableButtons(this);

            const url = $("#imageForm").attr("action");
            form.post(url, "#imageForm", "画像の更新が完了しました", pageImage.editDone);
        });
    },
    editDone: function (results) {
        modalWindow.hideModal("#js-modal-edit");

        // 成功したときのコールバック
        $('[data-imageid="' + results["imageId"] + '"]').html(results["template"]);
        pageImage.loadImageItem(results["imageId"]);
    }
};
